import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';

/**
 * Class holding the OpenLayers related logic for the assess tool.
 */
export default class OlAssessController {
  /* the OL map we want to measure on */
  map = null;

  constructor (olMap, measureConf) {
    this.map = olMap;
    this.measureConf = measureConf || {};
    this.assessLayer = undefined;
  }

  /**
   * Tears down this controller.
   */
  destroy () {
    if (!this.assessLayer || !this.map) {
      return;
    }
    this.removeInteraction();
    this.map.removeLayer(this.assessLayer);
    this.assessLayer = undefined;
  }

  /**
   * Creates a image layer for the assess results and adds it to the
   * map.
   */
  createAssessLayer (data) {
    const me = this;
    // create a vector layer to
    const source = new TileWMS({
      url: '/geoserver/ks/wms', // Use proxy
      // tileLoadFunction: (tile, src) => tileCustomLoader(tile, src, self.authorization),
      params: {
        LAYERS: data.layer || '',
        CQL_FILTER: data.filter || '',
        TILED: true
      },
      serverType: 'geoserver',
      crossOrigin: 'anonymous',
      transition: 0
    });
    this.assessLayer = new TileLayer({
      lid: 'wgu-assess-layer',
      displayInLayerList: false,
      source,
      visible: true,
      zIndex: 1 // Lower z-index  layer appears on top,Default z-index is 0.
    });

    me.map.addLayer(this.assessLayer);

    // make vector source available as member
    me.source = source;
  }

  /**
   * Removes the current interaction and clears the values.
   */
  removeInteraction () {
    if (this.draw) {
      this.map.removeInteraction(this.draw);
      this.draw = undefined;
    }
    if (this.source) {
      this.source.clear();
    }
  }
}
